import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import * as styles from "./ProgressSegment.css";

type ProgressSegmentProps = {
  isCompleted?: boolean;
  type?: 'square' | 'round',
  theme?: "colour" | "light";
} & ComponentPropsWithoutRef<"div">;

export const ProgressSegment = ({
  isCompleted = true,
  className,
  type = "square",
  theme = "colour",
  ...props
}: ProgressSegmentProps) => {
  return (
    <div className={clsx(className, styles.segment({disabled: isCompleted, type: type, theme: theme}))} {...props}> </div>
  );
};
